import { useEffect, useRef } from 'react';
import { useTheme as useMuiTheme } from '@mui/material/styles';
import { useTheme as useCustomTheme } from '../contexts/ThemeContext';
import statusBarService from '../services/StatusBarService';

/**
 * Hook to manage status bar styling with theme
 */
const useStatusBar = () => {
  const muiTheme = useMuiTheme();
  const { currentTheme, themeMode } = useCustomTheme();
  const lastThemeRef = useRef('');

  useEffect(() => {
    // Create a unique theme identifier
    const themeIdentifier = `${currentTheme.name}-${themeMode}`;
    
    // Only update if theme actually changed
    if (lastThemeRef.current !== themeIdentifier) {
      lastThemeRef.current = themeIdentifier;
      statusBarService.initialize(muiTheme);
    }
  }, [muiTheme, currentTheme.name, themeMode]);

  return {
    setStatusBarStyle: () => statusBarService.setStatusBarStyle(muiTheme),
    forceUpdate: () => statusBarService.forceUpdate(muiTheme),
    show: statusBarService.show.bind(statusBarService),
    hide: statusBarService.hide.bind(statusBarService),
    setOverlay: statusBarService.setOverlay.bind(statusBarService),
  };
};

export default useStatusBar; 